import React from 'react';
import MainLayout from '@/layouts/MainLayout/MainLayout.tsx';
import Container from '@/components/ui/Container/Container.tsx';
import Welcome from '@/pages/MyClimate/Welcome.tsx';
import UpcomingTrips from '@/pages/MyClimate/UpcomingTrips/UpcomingTrips.tsx';
import FlexBlock from '@/components/ui/FlexBlock/FlexBlock.tsx';
import CarbonFootprint from './CarbonFootprint/CarbonFootprint';
import LearnMore from './LearnMore/LearnMore';
import Metrics from './Metrics/Metrics';
import LogTrip from './LogTrip/LogTrip';
import styles from './MyClimate.module.scss';
import DataComplianceWarning from '@/pages/MyClimate/DataComplianceWarning/DataComplianceWarning.tsx';

const MyClimate: React.FC = () => {
	return (
		<MainLayout>
			<title>Goodwings - Compromise free travel</title>
			<Container>
				<div className={styles.mobileContainer}>
					<Welcome />
					<DataComplianceWarning />
					<FlexBlock flexDirection="column" rowGap="32px">
						<FlexBlock flexDirection="column" columnGap="32px" rowGap="32px">
							<UpcomingTrips />
							<FlexBlock rowGap="32px" columnGap="32px">
								<CarbonFootprint />
								<div className={styles.learnMoreWrapper}>
									<LearnMore />
								</div>
							</FlexBlock>
						</FlexBlock>

						<Metrics />
						<LogTrip />
					</FlexBlock>
				</div>
			</Container>
		</MainLayout>
	);
};

export default MyClimate;
